import styled, { css } from 'styled-components';

import { CardContent, defaultThemeProp } from '@pega/cosmos-react-core';

export const StyledEmailCardContent = styled(CardContent)(({ theme }) => {
  return css`
    &&&& {
      padding: calc(2 * ${theme.base.spacing}) 0;
    }
  `;
});

StyledEmailCardContent.defaultProps = defaultThemeProp;
